import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Flex,
  Grid,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Icon,
  Image
} from "@chakra-ui/react";
import {
  MdAddTask,
  MdAttachMoney,
  MdBarChart,
  MdFileCopy,
  MdBlockFlipped,
  MdCancel,
  MdCheckCircle,
  MdOutlineError,
  MdOutlineWatchLater,
  MdShoppingCart,
} from "react-icons/md";
import { IoMdAlert } from "react-icons/io";


import Card from "components/card/Card";
import Menu from "../components/MainMenu";
import Amazon from "assets/img/amazon.ico";
import Flipkart from "assets/img/flipkart.ico";
import Snapdeal from "assets/img/snapdeal.ico";
import Meesho from "assets/img/meesho.ico";
import Glowroad from "assets/img/glowroad.ico";

import ProductCard from "./ProductCard";

export default function SellerModal({ isOpen, onClose, seller, keywordIds }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [sellerProducts, setSellerProducts] = useState([]);
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));

  const fetchProducts = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/sellers/getSellerProducts`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uid: userInfo?.message?.result.id,
            sellerHash: seller.seller_hash,
            keywordIds: keywordIds,
          }),
        }
      );
      const json = await response.json();

      if (response.ok) {
        console.log(json.message)
        setSellerProducts(json.data);
      } else if (response.status === 400) {
        alert(json.message);
      }
    } catch (e) {
      console.log("error in fetchProducts", e)
    }
  }
  console.log("Products: ", sellerProducts)
  // console.log("inside modal: ", seller)

  useEffect(() => {
    fetchProducts();
  }, [seller?.seller_hash]);


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      {seller ? (
        <ModalContent maxWidth="80%">
          <ModalHeader>{seller?.seller_name}</ModalHeader>
          <ModalCloseButton />
          <ModalBody /*maxHeight="80vh" overflow="auto"*/>
            {/* {seller ? (
                <> */}
            <SimpleGrid
              columns={{ base: 1, md: 2, lg: 4 }}
              gap="20px"
              mb="20px"
            >
              {/* <Stat>
                      <StatLabel>Seller Name</StatLabel>
                      <StatNumber>{seller?.seller_name}</StatNumber>
                    </Stat> */}
              <Stat>
                <StatLabel>Seller Status</StatLabel>
                <StatNumber>
                  {seller?.seller_status === "W"
                    ? "Official Seller"
                    : seller?.seller_status === "C"
                      ? "Counterfeit Seller"
                      : "Suspicious Seller"}
                </StatNumber>
              </Stat>
              <Stat>
                <StatLabel>Test Purchase Status</StatLabel>
                <StatNumber style={{
                  color: seller.test_purchase_status === 4 ? "red" : (seller.test_purchase_status === 3 ? 'green':(seller.test_purchase_status === 1 || seller.test_purchase_status === 2 ? '#ffde09':'black')),
                }}>

                  {seller?.test_purchase_status == null
                    ? "Not tested"
                    : seller?.test_purchase_status === 3
                      ? "Genuine Product"
                      : seller?.test_purchase_status === 4
                        ? "Counterfeit"
                        : "Order in Progress"}
                </StatNumber>
              </Stat>
              <Stat>
                <StatLabel>Keywords</StatLabel>
                <StatNumber>{seller?.keyword}</StatNumber>
              </Stat>
              <Stat>
                <StatLabel>Platforms</StatLabel>
                <StatNumber>
                  <Image
                    boxSize="25px"
                    objectFit="cover"
                    src={
                      seller?.platform_id === 1
                        ? Amazon
                        : seller?.platform_id === 2
                          ? Flipkart
                          : seller?.platform_id === 3
                            ? Snapdeal
                            : seller?.platform_id === 4
                              ? Meesho
                              : seller?.platform_id === 5
                                ? Glowroad
                                : "No Platform"
                    }
                    alt="Platform Icon"
                    mr="5px"
                  />
                </StatNumber>
              </Stat>
            </SimpleGrid>
            <Grid mb="20px">
              <Flex
                flexDirection="column"
              >
                <SimpleGrid
                  columns={{ base: 1, sm: 2, md: 4 }}
                  gap="20px"
                >
                  {sellerProducts?.map((product, index) => {
                    return <ProductCard key={index} product={product} />;
                  })}
                </SimpleGrid>
              </Flex>
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      ) : (
        <></>
      )}
    </Modal>
  );
}
